export default "__VITE_ASSET__DscBULFt__"